import { Link } from "react-router-dom"
import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row, Label, Nav, NavItem, NavLink, Button, UncontrolledTooltip, Popover, PopoverHeader, PopoverBody, FormGroup, Alert } from 'reactstrap'
import Loader from "../Material/Loader"
import "react-awesome-lightbox/build/style.css"
import DatetimeRenderer from "../Material/DatetimeRenderer"
import gql from 'graphql-tag'
import DocumentModalNew from "../Material/DocumentModal/DocumentModalNew"
import { cleanDocumentUrl } from "../Material/DocumentModal/DocumentsListNew"
import Table from "reactstrap/lib/Table"
import Select from 'react-select'
import moment from 'moment'
import ConfirmationPopup from "../Material/ConfirmationPopup"
import toTitleCase from "../Functions/toTitleCase"
import withApolloClient from "../withApolloClient"
import UpdateIncidentInfo from "./Components/UpdateIncidentInfo"
import { CLEARABLE_INCIDENT_FIELDS } from "./Components/clearableIncidentFields"
import MoveDamagesModal from "../Material/MoveDamagesModal"
import "./RenderIncidentDetail.css"
import TransactionInfo from "../Billing/Transactions/TransactionInfo"
import { HasPermissionsQuery } from "../Functions/querys"
import DashcamContainer from "../Material/DashcamContainer"
import ArchiveReasonModal from "./IncidentModals/ArchiveReasonModal"
import IncidentDamagesTable from "./Shared/IncidentDamagesTable"

const IncidentDetailQuery = gql`query Incident($incidentId: ID!){
    incident(incidentId:$incidentId){
        id
        pk
        dateAdded
        incidentDate
        incidentTime
        notificationDate
        reportedBy
        description
        unarchivedRelatedIncidentCount
        vinRelatedIncidentCount
        metadata
        isArchived
        car {
            id
            pk
            branch {
                id
            }
        }
        carCondition {
            id
            car{
                id
                pk
            }
            incidentSet {
                edges {
                    node {
                        id
                        pk
                        dateAdded
                    }
                }
            }
        }
        driver {
            id
            branch {
                id
            }
        }
        branch {
            id
        }
        rental {
            id
            driver {
                id
                name
            }
            car{
                id
                pk
            }
            branch {
                id
            }
        }
        damageTransaction {
            id
            pk
            dateAdded
            dynamicAmount
            notes
            linkedPaymentPlan {
                id
                resultantTransactionsSum
            }
            chargeType {
                id
                name
            }
            updates {
                edges {
                    node {
                        id
                        linkedPaymentPlan {
                            id
                            resultantTransactionsSum
                        }
                    }
                }
            }
        }
        incidentdamageSet {
            edges {
                node {
                    id
                    excludeFromCdw
                    damage {
                        id
                        car {
                            id
                            pk
                        }
                        dateAdded
                        description: notes
                        issueDesc
                        status
                        reportedBy
                        canPickup
                        projectedCost
                        severity
                        pictures {
                            edges {
                                node {
                                    id
                                    dateAdded
                                    pictureUrl
                                    pictureType
                                    description
                                }
                            }
                        }
                        issueCategory {
                            id
                            name: category
                        }
                        vendor {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
}`

const AllTransactionsQuery = gql`query allTransactions($agreementId: ID!, $chargeTypeIds:[ID]){
    allTransactions(agreementId:$agreementId, chargeTypeIds:$chargeTypeIds){
        edges{
            node{
                id
                pk
                chargeTypeDisplay
                amount
                dateAdded
                agreement {
                    id
                }
            }
        }
      
    }     
}`

const CarIssuesSeverityLevelQuery = gql`{
  carIssueSeverityLevels: __type(name: "CarsCarIssuesSeverityChoices") {
    enumValues {
      name
      description
    }
  }
}
`

const DeleteIncidentMutation = gql`mutation DeleteIncidentMutation($input: DeleteIncidentMutationInput!){
    deleteIncident(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const UpdateIncidentMutation = gql`mutation UpdateIncidentMutation($input: UpdateIncidentMutationInput!){
    updateIncident(input:$input){
        ok
        errors{
            messages
        }
    }
} `


class RenderIncidentDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            error: null,
            loading: false,
            successMessage: "",
            showArchiveConfirm: false,
            archiveReason: "",
            showFullArchiveReason: false,
            reportedIssueSubsection: "reportedIssues",
            damageTransactionSubsection: "damageTransactions",
            incidentDetailSubsection: "incidentDetails",
            transactionId: "",
            transactions: [],
            incidentDate: moment().format('YYYY-MM-DD'),
            incidentTime: moment().format('HH:mm'),
            selectedDamages: [],
        }
    }

    toggleModal = (modalName) => {
        const isArchived = this.props.incident?.isArchived
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "", error: "" })
        } else {
            this.setState({
                openModal: modalName,
                error: "",
                loading: false,
                ...(modalName === "archiveIncident" && { showArchiveConfirm: !!isArchived, archiveReason: "" }),
            })
        }
    }

    handleArchiveReasonContinue = (reason) => {
        this.setState({ showArchiveConfirm: true, archiveReason: reason || "" })
    }

    toggleSectionNav = (sectionName, value) => {
        this.setState({ [sectionName]: value })
    }

    viewPictures = (carPictures, index = 0) => {
        let pictures = carPictures?.map(picture => ({ documentUrl: cleanDocumentUrl(picture.node.pictureUrl), id: picture.node.id, name: toTitleCase(picture.node.pictureType), description: picture.node.description, dateAdded: picture.node.dateAdded }))
        this.setState({ carPictures: pictures, selectedImage: pictures[index] })
    }
    next = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === carPictures.length - 1) return
        this.setState({ selectedImage: carPictures[currentIndex + 1] })
    }

    prev = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === 0) return
        this.setState({ selectedImage: carPictures[currentIndex - 1] })
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: "",
            successMessage: "",
            openModal: "",
            incidentDate: moment().format('YYYY-MM-DD'),
            incidentTime: moment().format('HH:mm'),
            selectedDamages: [],
            showArchiveConfirm: false,
            archiveReason: "",
            showFullArchiveReason: false,
        })
    }

    deleteIncident = (incidentId) => {
        try {
            if (incidentId) {
                this.setState({ loading: true })
                let input = {
                    incidentId: incidentId,
                }
                this.props.apolloClient.mutate({
                    mutation: DeleteIncidentMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.deleteIncident && result.data.deleteIncident.ok) {
                        this.setState({ errorMessage: "", successMessage: "Successfully Deleted Incident" })
                        this.props.refetchQuery()
                        this.handleClose()
                    } else {
                        let errorMessage = "An error occurred, could not complete request."
                        if (result.data && result.data.deleteIncident && result.data.deleteIncident.errors && result.data.deleteIncident.errors[0] && result.data.deleteIncident.errors[0].messages) {
                            errorMessage = result.data.deleteIncident.errors[0].messages.toString()
                        }
                        this.setState({ error: errorMessage })
                    }
                    this.setState({ loading: false })
                }).catch((err) => {
                    let errorMessage = "An error has occurred"
                    this.setState({ error: errorMessage, loading: false })
                })
            }
            else this.setState({ error: "Missing Required Field" })
        }
        catch (err) {
            let errorMessage = "An error has occurred"
            this.setState({ error: errorMessage, loading: false })
        }
    }

    toggleArchiveIncident = (incidentId, isArchived) => {
        try {
            if (incidentId) {
                this.setState({ loading: true })
                let input = {
                    incidentId: incidentId,
                    isArchived: !isArchived,
                }
                if (!isArchived && this.state.archiveReason) {
                    input.archiveReason = this.state.archiveReason.trim()
                }
                this.props.apolloClient.mutate({
                    mutation: UpdateIncidentMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.updateIncident && result.data.updateIncident.ok) {
                        this.setState({ errorMessage: "", successMessage: isArchived ? "Successfully Un-Archived The Incident." : "Successfully Archived The Incident.", loading: false })
                        this.props.refetchQuery()
                        this.handleClose()
                    } else {
                        let errorMessage = "An error occurred, could not complete request."
                        if (result.data && result.data.updateIncident && result.data.updateIncident.errors && result.data.updateIncident.errors[0] && result.data.updateIncident.errors[0].messages) {
                            errorMessage = result.data.updateIncident.errors[0].messages.toString()
                        }
                        this.setState({ error: errorMessage })
                    }
                    this.setState({ loading: false })
                }).catch((err) => {
                    let errorMessage = "An error has occurred"
                    this.setState({ error: errorMessage, loading: false })
                })
            }
            else this.setState({ error: "Missing Required Field" })
        }
        catch (err) {
            let errorMessage = "An error has occurred"
            this.setState({ error: errorMessage, loading: false })
        }
    }

    toggleArchiveReasonView = () => {
        this.setState(prev => ({
            showFullArchiveReason: !prev.showFullArchiveReason
        }))
    }

    fetchMetaData = (metadata = null, name) => {
        if (!metadata || metadata === "")
            return null
        try {
            metadata = JSON.parse(metadata.replace(/'/g, '"'))
        } catch {
            metadata = null
        }
        return metadata && metadata[name] ? metadata[name] : null
    }


    handleTransactionChange = (selectedOption) => {
        this.setState({ transactionId: selectedOption.value })
    }

    handleDamageSelection = (damageId) => {
        if (this.state.selectedDamages.includes(damageId)) {
            this.setState(prevState => ({
                selectedDamages: prevState.selectedDamages.filter(id => id !== damageId)
            }))
        } else {
            this.setState(prevState => ({
                selectedDamages: [...prevState.selectedDamages, damageId]
            }))
        }
    }

    updateIncidentDamageTransaction = (incidentId) => {
        try {
            if (incidentId) {
                this.setState({ loading: true })
                let input = {
                    incidentId: incidentId,
                }
                if (this.state.transactionId) {
                    input["damageTransactionId"] = this.state.transactionId
                }
                this.props.apolloClient.mutate({
                    mutation: UpdateIncidentMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.updateIncident && result.data.updateIncident.ok) {
                        this.setState({ errorMessage: "", successMessage: "Successfully Added Damages Transaction" })
                        this.props.refetchQuery()
                        this.handleClose()
                    } else {
                        let errorMessage = "An error occurred, could not complete request."
                        if (result.data && result.data.updateIncident && result.data.updateIncident.errors && result.data.updateIncident.errors[0] && result.data.updateIncident.errors[0].messages) {
                            errorMessage = result.data.updateIncident.errors[0].messages.toString()
                        }
                        this.setState({ error: errorMessage })
                    }
                    this.setState({ loading: false })
                }).catch((err) => {
                    let errorMessage = "An error has occurred:" + err
                    this.setState({ error: errorMessage, loading: false })
                })
            }
            else this.setState({ error: "Missing Required Field" })
        }
        catch (err) {
            let errorMessage = "An error has occurred:" + err
            this.setState({ error: errorMessage, loading: false })
        }
    }

    fetchTransactions = (agreementId) => {
        this.setState({ loading: true })
        let chargeTypeIds = []
        if (process.env.NODE_ENV === "development") {
            chargeTypeIds = ["Q2hhcmdlVHlwZU5vZGU6NTQ=", "Q2hhcmdlVHlwZU5vZGU6NTM="]
        }
        else if (process.env.NODE_ENV === "production") {
            chargeTypeIds = ["Q2hhcmdlVHlwZU5vZGU6MjI=", "Q2hhcmdlVHlwZU5vZGU6MjE="]
        }
        this.props.apolloClient.query({
            query: AllTransactionsQuery,
            variables: {
                agreementId: agreementId,
                chargeTypeIds: chargeTypeIds
            }
        }).then(response => {
            if (response && response.data && response.data.allTransactions && response.data.allTransactions.edges.length > 0) {
                const transactions = response.data.allTransactions.edges.map(edge => ({
                    value: edge.node.pk,
                    label: `${edge.node.pk} | ${edge.node.chargeTypeDisplay} | $${edge.node.amount} | ${moment(edge.node.dateAdded).format('YYYY-MM-DD')}`
                }))
                this.setState({ transactions })
                this.setState({ loading: false })
            }
        }).catch(error => {
            this.setState({ error: "Error fetching transactions: " + error })
            this.setState({ loading: false })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.openModal !== prevState.openModal) {
            if (this.state.openModal === "updateIncidentDate" || this.state.openModal === "updateIncidentTime") {
                const incident = this.props.incident
                if (incident) {
                    this.setState({
                        incidentDate: incident.incidentDate ? moment(incident.incidentDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                        incidentTime: incident.incidentTime || moment().format('HH:mm'),
                    })
                }
            } else if (this.state.openModal === "addNewIncident") {
                this.setState({
                    incidentDate: moment().format('YYYY-MM-DD'),
                    incidentTime: moment().format('HH:mm'),
                })
            }
        }

        if (!prevProps.incident && this.props.incident && this.props.incident.id && this.props.incident.rental && this.props.incident.rental.id) {
            this.fetchTransactions(this.props.incident.rental.id)
        }
    }

    render() {
        const { incident } = this.props
        const permissions = this.props?.hasPermissions ?? []
        return (
            <>
                {this.state.selectedImage &&
                    <DocumentModalNew
                        document={this.state.selectedImage}
                        handleClose={() => this.setState({ selectedImage: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"car"}
                        isPicture={true}
                        refetch={this.props.refetch}
                        currentUser={this.props.currentUser}
                    />
                }
                {this.props.incidentLoading ? <Loader /> :
                    incident ? <span className="incident-detail">
                        {incident?.isArchived && (
                            <div className="m-3 archived-incident-alert">
                                <div className="archived-incident-alert-content">
                                    <p className="archived-incident-alert-title mb-0">
                                        <b><i className="fa fa-archive" aria-hidden="true" /> This incident is <span style={{ color: "#d9534f" }}>archived</span> and is read-only.</b>
                                    </p>
                                    <div className="archived-incident-alert-reason pt-1">
                                        <p className="archived-incident-alert-reason-text mb-0">
                                            <b>Archive Reason: </b>
                                            {(() => {
                                                const reason = this.fetchMetaData(incident?.metadata, "archive_reason") || "No reason provided."
                                                const reasonText = reason.trim().split(/\s+/)
                                                return (
                                                    <>
                                                        {reasonText.length > 15 && !this.state.showFullArchiveReason ? `${reasonText.slice(0, 15).join(" ")}...` : reason}
                                                        {reasonText.length > 15 && <button type="button" className="btn btn-link btn-sm p-0 ml-2" onClick={this.toggleArchiveReasonView}>{this.state.showFullArchiveReason ? "View less" : "View more"}</button>}
                                                    </>
                                                )
                                            })()}
                                        </p>
                                    </div>
                                </div>
                                {permissions?.includes("archive_incident") && (
                                    <button className="btn btn-success btn-sm" onClick={() => this.toggleModal("archiveIncident")}>
                                        <i className="fa fa-undo"></i>&nbsp;Un-Archive
                                    </button>
                                )}
                            </div>
                        )}
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={this.state.incidentDetailSubsection === "incidentDetails" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("incidentDetailSubsection", "incidentDetails")}>
                                    INCIDENT #{incident?.pk}
                                </NavLink>
                            </NavItem>
                            {permissions?.includes("view_dashcamrecord") &&
                                <NavItem>
                                    <NavLink className={this.state.incidentDetailSubsection === "dashcamrecording" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("incidentDetailSubsection", "dashcamrecording")}>
                                        DASHCAM RECORDINGS
                                    </NavLink>
                                </NavItem>
                            }
                        </Nav>
                        {this.state.incidentDetailSubsection === "incidentDetails" && <div className="info-container" style={{ borderTopLeftRadius: "0px", padding: 3 }}>
                            <Row className="m-3">
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>
                                        {this.props.viewType === "car" ?
                                            <>
                                                Driver
                                                {permissions?.includes("change_incident") && !incident.rental?.driver && <>
                                                    &nbsp;&nbsp;<i className="fa fa-pencil-square-o cursor-pointer" onClick={() => this.toggleModal("updateIncidentDriver")} id="updateIncidentDriver" />
                                                </>}
                                            </> :
                                            "Car"
                                        }
                                    </Label>
                                    <div>
                                        {this.props.viewType === "car"
                                            ? incident.rental
                                                ? <Link to={`/driver/${incident.rental.driver.id}`}>
                                                    {incident.rental.driver.name} <i className="fa fa-external-link color-blue" />
                                                </Link>
                                                : "No Rental/Driver Found!"
                                            : incident.rental
                                                ? <Link to={`/car/${incident.rental.car.pk}`}>
                                                    {incident.rental.car.pk} <i className="fa fa-external-link color-blue" />
                                                </Link>
                                                : "No Rental/Car Found!"
                                        }
                                        {this.state.openModal === "updateIncidentDriver" &&
                                            <UpdateIncidentInfo
                                                title="Edit Incident Driver"
                                                name="rentalId"
                                                type="select"
                                                value={incident.rental ? incident.rental.id : ""}
                                                carPk={this.props.incident?.rental?.car?.pk || this.props.incident?.carCondition?.car?.pk}
                                                open={true}
                                                target="updateIncidentDriver"
                                                handleClose={() => this.toggleModal("")}
                                                incidentId={incident.id}
                                                refetchIncident={this.props.refetchQuery}
                                            />
                                        }
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>Date Added</Label>
                                    <div>{incident.dateAdded ? <DatetimeRenderer datetime={incident.dateAdded} /> : "---"}</div>
                                </Col>
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>
                                        Incident Date&nbsp;&nbsp;
                                        {!incident.isArchived && <i className="fa fa-pencil-square-o cursor-pointer" onClick={() => this.toggleModal("updateIncidentDate")} id="updateIncidentDate" />}
                                    </Label>
                                    <div>{incident.incidentDate ? moment(incident.incidentDate).format("MM/DD/YYYY") : "---"}</div>
                                    {this.state.openModal === "updateIncidentDate" && (
                                        <UpdateIncidentInfo
                                            title="Edit Incident Date"
                                            name="incidentDate"
                                            type="date"
                                            value={incident.incidentDate ? moment(incident.incidentDate).format("YYYY-MM-DD") : null}
                                            open
                                            target="updateIncidentDate"
                                            clearInputFlag={CLEARABLE_INCIDENT_FIELDS.incidentDate.inputFlag}
                                            handleClose={() => this.toggleModal("")}
                                            incidentId={incident.id}
                                            refetchIncident={this.props.refetchQuery}
                                        />
                                    )}
                                </Col>
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>
                                        Incident Time&nbsp;&nbsp;
                                        {!incident.isArchived && <i className="fa fa-pencil-square-o cursor-pointer" onClick={() => this.toggleModal("updateIncidentTime")} id="updateIncidentTime" />}
                                    </Label>
                                    <div>{incident.incidentTime ? moment(incident.incidentTime, "HH:mm:ss").format("h:mm A") : "---"}</div>
                                    {this.state.openModal === "updateIncidentTime" && (
                                        <UpdateIncidentInfo
                                            title="Edit Incident Time"
                                            name="incidentTime"
                                            type="time"
                                            value={incident.incidentTime || null}
                                            open
                                            target="updateIncidentTime"
                                            clearInputFlag={CLEARABLE_INCIDENT_FIELDS.incidentTime.inputFlag}
                                            handleClose={() => this.toggleModal("")}
                                            incidentId={incident.id}
                                            refetchIncident={this.props.refetchQuery}
                                        />
                                    )}
                                </Col>
                            </Row>
                            <Row className="m-3">
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>
                                        Notification Date&nbsp;&nbsp;
                                        {!incident.isArchived && <i className="fa fa-pencil-square-o cursor-pointer" onClick={() => this.toggleModal("updateIncidentNotificationDate")} id="updateIncidentNotificationDate" />}
                                    </Label>
                                    <div>{incident.notificationDate ? <DatetimeRenderer
                                        datetime={incident.notificationDate}
                                        driverId={incident.driver?.id}
                                        branchId={incident.branch?.id || incident.driver?.branch?.id || incident.rental?.branch?.id || incident.car?.branch?.id}
                                    /> : "---"}</div>
                                    {this.state.openModal === "updateIncidentNotificationDate" && (
                                        <UpdateIncidentInfo
                                            title="Edit Incident Notification Datetime"
                                            name="notificationDatetime"
                                            type="datetime-local"
                                            value={incident.notificationDate}
                                            min={incident.incidentDate}
                                            max={moment()}
                                            open
                                            target="updateIncidentNotificationDate"
                                            handleClose={() => this.toggleModal("")}
                                            incidentId={incident.id}
                                            refetchIncident={this.props.refetchQuery}
                                            branchId={incident.branch?.id || incident.driver?.branch?.id || incident.rental?.branch?.id || incident.car?.branch?.id}
                                        />
                                    )}
                                </Col>
                                <Col xs={3}>
                                    <Label style={{ fontWeight: 600 }}>
                                        Reported By&nbsp;&nbsp;
                                        {!incident.isArchived && <i className="fa fa-pencil-square-o cursor-pointer" onClick={() => this.toggleModal("updateReportedBy")} id="updateReportedBy" />}
                                    </Label>
                                    <div>{incident.reportedBy ? toTitleCase(incident.reportedBy) : "---"}</div>
                                    {this.state.openModal === "updateReportedBy" && (
                                        <UpdateIncidentInfo
                                            title="Edit Reported By"
                                            name="reportedBy"
                                            type=""
                                            value={incident.reportedBy}
                                            open
                                            target="updateReportedBy"
                                            handleClose={() => this.toggleModal("")}
                                            incidentId={incident.id}
                                            refetchIncident={this.props.refetchQuery}
                                        />
                                    )}
                                </Col>
                                {incident.isArchived && <Col xs={3} className="mt-2">
                                    <Label style={{ fontWeight: 600 }}>
                                        Is Archived
                                    </Label>
                                    <div>YES</div>
                                </Col>}
                                {this.props.viewType === "driver" && (incident?.vinRelatedIncidentCount > 0 || incident?.unarchivedRelatedIncidentCount  > 0) && (
                                    <Col xs={3} className="mt-2">
                                        <Label style={{ fontWeight: 600 }}>Related / Duplicate</Label>
                                        <div className="incident-quick-insights__indicators">
                                            <span className="bos-badge-small badge bg-success p-2">
                                                <i className="fa fa-link" aria-hidden="true" />&nbsp;&nbsp;{incident?.vinRelatedIncidentCount || 0} Related
                                            </span>&nbsp;&nbsp;
                                            <span className="bos-badge-small badge bg-danger p-2">
                                                <i className="fa fa-clone" aria-hidden="true" />&nbsp;&nbsp;{incident?.unarchivedRelatedIncidentCount || 0} Duplicate
                                            </span>
                                        </div>
                                    </Col>
                                )}
                                <Col xs={3} className="mt-2">
                                    <Label style={{ fontWeight: 600 }}>Action</Label>
                                    <div>
                                        <Link to={`/incident/${incident.id}`}>
                                            <i className="fa fa-eye" style={{ fontSize: 20 }} title="View Incident" />&nbsp;&nbsp;
                                        </Link>
                                        {incident.isArchived === false && this.props.hasPermissions?.includes("archive_incident") && <>
                                            <i className="fa fa-archive text-warning" aria-hidden="true" style={{ fontSize: 20 }} onClick={() => this.toggleModal("archiveIncident")} id="archiveIncident" />&nbsp;&nbsp;
                                            <UncontrolledTooltip target="archiveIncident">Archive Incident</UncontrolledTooltip>
                                        </>}

                                        {!((incident.damageTransaction && incident.damageTransaction.id) || (incident.incidentdamageSet?.edges?.length > 0)) && this.props.hasPermissions?.includes("delete_incident") && <>
                                            <i className="fa fa-trash text-danger" style={{ fontSize: 20 }} onClick={() => this.toggleModal("deleteIncident")} id="deleteIncident" />
                                            <UncontrolledTooltip target="deleteIncident">Delete Incident</UncontrolledTooltip>
                                        </>}
                                    </div>
                                    {this.state.openModal === "deleteIncident" && (
                                        <ConfirmationPopup
                                            open
                                            title="Delete Incident"
                                            loading={this.props.loading}
                                            message="Are you sure you want to delete this incident?"
                                            handleClose={() => this.toggleModal("deleteIncident")}
                                            action="Delete Incident"
                                            confirmAction={() => this.deleteIncident(incident.id)}
                                            color="danger"
                                            error={this.state.error}
                                            success={this.state.successMessage || ""}
                                        />
                                    )}
                                    {this.state.openModal === "archiveIncident" && !this.state.showArchiveConfirm && !incident?.isArchived && (
                                        <ArchiveReasonModal
                                            isOpen
                                            isArchived={incident?.isArchived}
                                            onCancel={() => this.toggleModal("archiveIncident")}
                                            onContinue={this.handleArchiveReasonContinue}
                                        />
                                    )}
                                    {this.state.openModal === "archiveIncident" && this.state.showArchiveConfirm && (
                                        <ConfirmationPopup
                                            open
                                            title={incident?.isArchived ? "Un-Archive Incident" : "Archive Incident"}
                                            loading={this.state.loading}
                                            message={`Are you sure you want to ${incident?.isArchived ? "un-archive" : "archive"} this incident?`}
                                            handleClose={() => this.toggleModal("archiveIncident")}
                                            action={incident?.isArchived ? "Un-Archive Incident" : "Archive Incident"}
                                            confirmAction={() => this.toggleArchiveIncident(incident.id, incident?.isArchived)}
                                            color={incident?.isArchived ? "success" : "danger"}
                                            error={this.state.error}
                                            success={this.state.successMessage || ""}
                                        />
                                    )}
                                </Col>
                            </Row>
                            {this.props.viewType === "driver" && (
                                <Row className="m-3 incident-quick-insights">
                                    <Col xs={12}>
                                        <Label style={{ fontWeight: 600 }}>Description</Label>
                                        <div className="incident-quick-insights__description">
                                            {incident?.description?.trim() || "No description provided."}
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </div>}
                        {this.state.incidentDetailSubsection === "dashcamrecording" && <DashcamContainer carId={incident?.car?.id} rentalId={incident?.rental?.id || null} incidentDate={incident?.incidentDate || null} />}
                        <br />
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={this.state.reportedIssueSubsection === "reportedIssues" ? "active navItem" : "navItem"}>
                                    INCIDENT DAMAGES
                                </NavLink>
                            </NavItem>
                            {this.state.selectedDamages.length > 0 && this.props.viewType === "car" && (
                                <div className="ml-auto">
                                    <Button color="primary" onClick={() => this.setState({ openModal: "moveDamgesModal" })}>
                                        Move Selected Damages
                                    </Button>
                                </div>
                            )}
                        </Nav>
                        {this.state.reportedIssueSubsection === "reportedIssues" &&
                            <div className="info-container" style={{ borderTopLeftRadius: "0px", padding: 3 }}>
                                {!this.state.openModal && this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                                <IncidentDamagesTable
                                    variant="legacy"
                                    damages={this.props.incident?.incidentdamageSet?.edges}
                                    carIssueSeverityLevels={this.props.carIssueSeverityLevels}
                                    selectedDamages={this.state.selectedDamages}
                                    onToggleSelection={this.handleDamageSelection}
                                    onViewPictures={this.viewPictures}
                                    refetchQuery={this.props.refetchQuery}
                                    hasPermissions={this.props.hasPermissions}
                                    onError={(message) => this.setState({ error: message, successMessage: "" })}
                                />
                            </div>
                        }
                        <br />
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={"active navItem"}>
                                    DAMAGE TRANSACTIONS
                                </NavLink>
                            </NavItem>
                            {this.props.viewType === "car" && <div className="ml-auto">
                                {!incident.damageTransaction && incident.incidentdamageSet && incident.incidentdamageSet.edges && incident.incidentdamageSet.edges.length > 0 &&
                                    <div>
                                        <Button id={"editDamageTransaction"} color="primary" onClick={() => this.setState({ openModal: "editDamageTransaction" })}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
                                        <UncontrolledTooltip target={"editDamageTransaction"}>Edit Damage Transaction</UncontrolledTooltip>
                                    </div>
                                }
                            </div>}
                            {this.state.openModal === "editDamageTransaction" && <Popover trigger="legacy" placement="left" target={"editDamageTransaction"} isOpen={this.state.openModal === "editDamageTransaction"} toggle={() => this.toggleModal("editDamageTransaction")}>
                                <PopoverHeader>Edit Damage Transaction</PopoverHeader>
                                <PopoverBody style={{ width: 370 }}>
                                    <Row>
                                        {this.state.error && <Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col>}
                                        {this.state.successMessage && <Col xs={12}><Alert color="success">{this.state.successMessage}</Alert></Col>}
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label style={{ fontWeight: 600 }}>Select Transaction</Label>
                                                <Select
                                                    className="bos-custom-select"
                                                    classNamePrefix="bos-select"
                                                    onChange={this.handleTransactionChange}
                                                    options={this.state.transactions}
                                                    placeholder="Select Transaction"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="text-right">
                                            <Button color="primary" onClick={() => this.updateIncidentDamageTransaction(incident.id)} disabled={this.state.loading || !(this.state.transactionId)}>{this.state.loading ? "Loading..." : "Update"}</Button>{' '}
                                        </Col>
                                    </Row>
                                </PopoverBody>
                            </Popover>
                            }
                        </Nav>
                        {this.state.damageTransactionSubsection === "damageTransactions" &&
                            <div className="info-container" style={{ borderTopLeftRadius: "0px", padding: 3 }}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th style={{ fontWeight: 500 }}>ID</th>
                                            <th style={{ fontWeight: 500 }}>Date Added</th>
                                            <th style={{ fontWeight: 500 }}>Charge Type</th>
                                            <th style={{ fontWeight: 500 }}>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {incident?.damageTransaction ?
                                            <>
                                                {this.state.openModal === ("TransactionInfo" + incident.damageTransaction.pk) && (
                                                    <TransactionInfo
                                                        id={incident.damageTransaction.id}
                                                        refetchQuery={this.props.refetchQuery}
                                                        handleClose={() => this.toggleModal("TransactionInfo" + incident.damageTransaction.pk)}
                                                        open={this.state.openModal === ("TransactionInfo" + incident.damageTransaction.pk)}
                                                        currentUser={this.props.currentUser}
                                                    />
                                                )}
                                                <tr>
                                                    <td><small>{incident.damageTransaction.pk}</small></td>
                                                    <td><small>{incident.damageTransaction.dateAdded ? <DatetimeRenderer datetime={incident.damageTransaction.dateAdded} placement="right" /> : "---"}</small></td>
                                                    <td onClick={() => this.toggleModal("TransactionInfo" + incident.damageTransaction.pk)} style={{ cursor: "pointer" }}><small>{incident.damageTransaction.chargeType ? incident.damageTransaction.chargeType.name : "---"}<br /><small>{incident.damageTransaction.notes}</small></small></td>
                                                    <td><small>${incident.damageTransaction?.linkedPaymentPlan?.resultantTransactionsSum || incident.damageTransaction.updates?.edges?.find(txn => txn.node.linkedPaymentPlan)?.node?.linkedPaymentPlan?.resultantTransactionsSum || (incident.damageTransaction.dynamicAmount ? incident.damageTransaction.dynamicAmount : "---")}</small></td>
                                                </tr>
                                            </>
                                            : <tr><td colSpan={4} style={{ color: "red" }}>No Damage Transactions Found!</td></tr>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        }
                    </span> : <p>No incident detail found!</p>
                }
                {this.state.openModal === "moveDamgesModal" && <MoveDamagesModal
                    isOpen={this.state.openModal === "moveDamgesModal"}
                    inspectionId={this.props.incident?.carCondition?.id}
                    damageIds={this.state.selectedDamages}
                    carId={this.props.incident?.rental?.car?.id || this.props.incident?.carCondition?.car?.id}
                    handleClose={this.handleClose}
                    refetchQuery={this.props.refetchQuery}
                />}
            </>
        )
    }
}

export default graphql(IncidentDetailQuery, {
    options: ({ id }) => ({
        variables: { incidentId: id },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { incident, loading, refetch, variables } }) => ({
        incident,
        incidentLoading: loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: IncidentDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { incident: fetchMoreResult.incident }
                },
            })
        },
    }),
})(
    graphql(CarIssuesSeverityLevelQuery, {
        props: ({ data: { carIssueSeverityLevels, loading } }) => ({
            carIssueSeverityLevels,
            loading,
        }),
    })(
        graphql(HasPermissionsQuery, {
            options: () => ({
                variables: {
                    userPermissions: [
                        "change_incident",
                        "view_dashcamrecord",
                        "delete_incident",
                        "archive_incident",
                        "change_incidentdamage"
                    ],
                },
                fetchPolicy: "network-only",
                notifyOnNetworkStatusChange: true,
            }),
            props: ({ data: { hasPermissions, loading, variables } }) => ({
                hasPermissions,
                loading,
                variables,
            }),
        })(withApolloClient(RenderIncidentDetail))
    )
)
